import React, { useState, useEffect } from "react";
import { Modal, Input, Button } from "../../../components/ui";
import { useAppMutation } from "../../../api/fetchClient";
import { UPDATE_COUNTRY_EMAIL } from "../../../api/url";
import { strings } from "../../../strings/strings";

const EditCountryEmailModal = ({ isOpen, onClose, country, onSuccess }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const mutation = useAppMutation();

  useEffect(() => {
    if (country) {
      setEmail(country.country_email || "");
      setError("");
    }
  }, [country]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      await mutation.mutateAsync({
        url: UPDATE_COUNTRY_EMAIL,
        method: "PUT",
        data: {
          country_id: country.id.toString(),
          country_email: email.trim()
        }
      });

      onSuccess();
      onClose();
    } catch (error) {
      setError(error.apiMessage || "Failed to update email");
    }
  };

  const handleClose = () => {
    setEmail("");
    setError("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`Edit Email - ${country?.countryName || country?.name}`}
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Country Email"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (error) setError("");
          }}
          placeholder="Enter country email"
          required
          error={error}
          touched={!!error}
        />

        <div className="flex justify-end gap-3 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={handleClose}
            disabled={mutation.isPending}
          >
            {strings.cancel || "Cancel"}
          </Button>
          <Button
            type="submit"
            variant="primary"
            isLoading={mutation.isPending}
            disabled={mutation.isPending}
          >
            {strings.update || "Update"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default EditCountryEmailModal;